// extracted by mini-css-extract-plugin
export var CollapsibleLinksListContainer = "CollapsibleLinksList-module--CollapsibleLinksListContainer--4d8a4";
export var buttonClean = "CollapsibleLinksList-module--buttonClean--eb43a";
export var buttonToggled = "CollapsibleLinksList-module--buttonToggled--5bee7";
export var classic = "CollapsibleLinksList-module--classic--7d431";
export var containerNoToggle = "CollapsibleLinksList-module--containerNoToggle--918b3";
export var group = "CollapsibleLinksList-module--group--4853c";
export var groupContainer = "CollapsibleLinksList-module--groupContainer--92111";
export var groupHeading = "CollapsibleLinksList-module--groupHeading--d93c8";
export var groupList = "CollapsibleLinksList-module--groupList--433d0";
export var headingNoToggle = "CollapsibleLinksList-module--headingNoToggle--625fe";
export var isHidden = "CollapsibleLinksList-module--isHidden--f6e7a";
export var listClean = "CollapsibleLinksList-module--listClean--a3a28";
export var listContainer = "CollapsibleLinksList-module--listContainer--16b71";
export var listContainerHeading = "CollapsibleLinksList-module--listContainerHeading--18aaa";
export var listContainerMarginTop = "CollapsibleLinksList-module--listContainerMarginTop--769dc";
export var listContainerNav = "CollapsibleLinksList-module--listContainerNav--c1f6d";
export var listContainerToggleButtons = "CollapsibleLinksList-module--listContainerToggleButtons--f8bf8";
export var simple = "CollapsibleLinksList-module--simple--aa712";